import { useMemo } from 'react'

import { Header } from '@cox/core-ui8/dist/Header'

import withAEM from '../../hoc/withAEM'

const ReactHeader = (props: any): JSX.Element => {
  const ReactHeaderWithAEM = useMemo(() => withAEM(Header), [])
  return <ReactHeaderWithAEM {...props} compName={'Header'} atomSpacing={true} />
}

export default ReactHeader
